export default "__VITE_ASSET__BV_dVnOD__"